import styled, { css } from 'styled-components';
export const BaseButtonStyle = css`
  border: none;
  cursor: pointer;

  background: none;

  transition: all 0.2s ease-in-out;

  &:disabled {
    opacity: 0.5;
  }
`;
export const Container = styled.button`
  position: relative;
  width: 100%;
  height: 100%;

  ${BaseButtonStyle}

  ${({
  noHover
}) => !noHover && css`
      &:hover:not(:disabled) {
        transform: scale(1.1);
      }
    `}
`;